const courses = {
  courses: 'Cursos',
  coursesList: 'Lista de Cursos',
  name: 'Nombre',
  grade: 'Grado',
  section: 'Sección',
  joinCode: 'Código de Acceso',
  status: 'Estado',
  active: 'Activo',
  inactive: 'Inactivo',
  total: 'Total',
  studentCount: 'Estudiantes',
  courseName: 'Nombre del curso',
  filterByGrade: 'Filtrar por grado',
  filterByStatus: 'Filtrar por estado',
  search: 'Buscar',
  deactivate: 'Desactivar',
  activate: 'Activar',
  confirmDeactivate: 'Confirmar desactivación',
  confirmActivate: 'Confirmar activación',
  deactivateWarning: 'Al desactivar este curso, los estudiantes no podrán acceder a él hasta que sea reactivado.',
  activateInfo: 'Al activar este curso, los estudiantes podrán acceder nuevamente a él.',
  hasActiveStudentsWarning: 'Este curso tiene estudiantes activos. Al desactivarlo, perderán acceso al contenido.',
  courseActivated: 'Curso activado exitosamente',
  courseDeactivated: 'Curso desactivado exitosamente',
  errorLoadingCourses: 'Error al cargar los cursos',
  errorUpdatingCourse: 'Error al actualizar el curso',
  errorActivating: 'Error al activar el curso',
  errorDeactivating: 'Error al desactivar el curso',
  codeCopied: 'Código copiado al portapapeles',
  errorCopyingCode: 'Error al copiar el código',
};

export default courses;
